import { setError } from '../filters';
import { ECurrentErrorField } from '../../actions/filters/types';
/**
 * Валидатор фильтров для типа оцениваемой недвижимости "ЖК"
 * Проверяет наличие обязательного поля: Адрес
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export var validateJKFilters = function validateJKFilters() {
  return function (dispatch, getState) {
    var state = getState();
    var address = state.filters.address;

    if (!address) {
      dispatch(setError({
        currentErrorField: ECurrentErrorField.address,
        errorText: 'Укажите адрес или название ЖК'
      }));
      return false;
    }

    return true;
  };
};